
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.008.01C4.048.01.01 4.048.01 9.008s4.038 8.998 8.998 8.998 8.998-4.038 8.998-8.998S13.968.01 9.008.01zm0 1.687c4.048 0 7.31 3.263 7.31 7.311s-3.262 7.31-7.31 7.31a7.299 7.299 0 01-7.31-7.31 7.298 7.298 0 017.31-7.31z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M9.852 4.236a.844.844 0 10-1.688 0v3.928H4.236a.844.844 0 100 1.688h3.928v3.928a.844.844 0 001.688 0V9.852h3.928a.844.844 0 100-1.688H9.852z","clip-rule":"evenodd"}})])
          )
        }
      }
    